function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 4C9.4 4 4 9.4 4 16s5.4 12 12 12 12-5.4 12-12S22.6 4 16 4z",
  fill: "#FC4F52"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21 19.6L19.6 21 16 17.4 12.4 21 11 19.6l3.6-3.6-3.6-3.6 1.4-1.4 3.6 3.6 3.6-3.6 1.4 1.4-3.6 3.6 3.6 3.6z",
  fill: "#fff"
});

var SvgIconCancelRNormal = function SvgIconCancelRNormal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNiA0QzkuNCA0IDQgOS40IDQgMTZDNCAyMi42IDkuNCAyOCAxNiAyOEMyMi42IDI4IDI4IDIyLjYgMjggMTZDMjggOS40IDIyLjYgNCAxNiA0WiIgZmlsbD0iI0ZDNEY1MiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIxIDE5LjZMMTkuNiAyMUwxNiAxNy40TDEyLjQgMjFMMTEgMTkuNkwxNC42IDE2TDExIDEyLjRMMTIuNCAxMUwxNiAxNC42TDE5LjYgMTFMMjEgMTIuNEwxNy40IDE2TDIxIDE5LjZaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgIconCancelRNormal as ReactComponent };